import { Component, HostListener } from '@angular/core';
import { ButtonModule } from '@usitsdasdesign/dds-ng/button';

@Component({
  selector: 'app-scroll-top',
  standalone: true,
  imports: [
    ButtonModule
  ],
  templateUrl: './scroll-top.component.html',
  styleUrl: './scroll-top.component.scss'
})
export class ScrollTopComponent {
  @HostListener('window:scroll', [])
  onWindowScroll() {
    this.isScrolled = window.scrollY > 50;
  }

  isScrolled: boolean;

  scrollToTop(): void {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}
